import React from 'react';

import { Box } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

export const NO_DATA_MODES = {
	error: {
		header: 'Something went wrong',
		message: 'Server did not respond or had an error. Try again later!',
		key: 'error',
	},
	noresult: {
		header: 'No results',
		message: 'No matching records found. Please try a different search.',
		key: 'noresults',
	},
};

/**
 * @param {{ mode: 'error' | 'noresult', customHeader?: string, customMessage?: string }} props
 */
const NoData = ({ mode, customHeader, customMessage }) => {
	const currentMode = Object.hasOwn(NO_DATA_MODES, mode)
		? NO_DATA_MODES[mode]
		: NO_DATA_MODES.error;
	const header = customHeader ? customHeader : currentMode.header;
	const message = customMessage ? customMessage : currentMode.message;

	return (
		<Box extraClasses={styles.noresults}>
			<h3>{header}</h3>
			<p>{message}</p>
		</Box>
	);
};

export default NoData;
